import { ITimeTrackerLocalStorage, TIME_TRACKER_LOCALSTORAGE } from '../types';

export const getTimeTrackerLocalStorage = (): ITimeTrackerLocalStorage => {
    const data = localStorage.getItem(TIME_TRACKER_LOCALSTORAGE);
    return data ? JSON.parse(data): null;
};
